import {
  Outlet,
  createFileRoute,
  redirect,
  stripSearchParams,
} from "@tanstack/react-router";
import * as z from "zod/v4";
import { zodValidator } from "@tanstack/zod-adapter";
import { LoadingSpinner } from "@/components/loading";
import { isLoggedIn } from "@/lib/http";

const authLayoutSearchSchema = z.object({
  redirect: z.string().optional(),
  redirectSearch: z.record(z.string().min(1), z.any()).optional(),
});

export const Route = createFileRoute("/auth")({
  validateSearch: zodValidator(authLayoutSearchSchema),
  search: {
    middlewares: [
      stripSearchParams({
        redirect: "/",
        redirectSearch: {},
      }),
    ],
  },
  beforeLoad({ search: { redirect: redirectPath, redirectSearch } }) {
    if (isLoggedIn()) {
      throw redirect({
        to: redirectPath ?? "/",
        search: redirectSearch,
      });
    }
  },
  pendingComponent: () => (
    <div className="flex h-screen w-screen grow items-center justify-center">
      <LoadingSpinner size={48} />
    </div>
  ),
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <>
      <div className="flex flex-1 flex-col py-4">
        <div className="mt-8 mb-8">
          <Outlet />
        </div>
      </div>
    </>
  );
}
